import React from 'react'
import style from './articles.style'

const DSView = ({ classes }) => {
  return (
    <article className={classes.article}>
      <h2>Как создать новое представление в Google Analytics</h2>

      <p>
        Мы&nbsp;рекомендуем передавать данные в&nbsp;отдельное представление
        Google Analytics, это исключает возможность пересечения ваших данных
        с&nbsp;данными ROMI&nbsp;center.
      </p>
      <h3>Шаг 1. Создание нового представления для ROMI center.</h3>

      <ol>
        <li>Перейдите в&nbsp;Google Analytics.</li>
        <li>
          Перейдите на&nbsp;вкладку <strong>Администратор</strong>
        </li>
        <li>
          В настройках <strong>Представления</strong>(третий столбец) нажмите
          кнопку <strong>Создать представление</strong>.
        </li>
        <figure className={classes.helpArticleFigure}>
          <img src="/images/image4GA.jpg" alt="true" />
        </figure>
        <li>
          Напишите <strong>название представления (ROMI center)</strong>{' '}
          и&nbsp;выберите <strong>часовой пояс.</strong>
        </li>
        <li>
          Нажмите кнопку <strong>Создать представление</strong>.
        </li>
        <figure className={classes.helpArticleFigure}>
          <img src="/images/image6GA.jpg" alt="true" />
        </figure>
        <li>
          После создания нового представления перейдите в&nbsp;настройки
          <strong>(Администратор&nbsp;→ Настройки представления);</strong>
        </li>
        <figure className={classes.helpArticleFigure}>
          <img src="/images/image1GA.jpg" alt="true" />
        </figure>
        <li>
          В поле <strong>Валюта</strong> поменяйте “Доллар США” на&nbsp;
          <strong>Российский рубль</strong>
        </li>
        <li>
          <strong>
            Отключите галочку: &laquo;Исключить обращения роботов
            и&nbsp;&bdquo;пауков&ldquo;&raquo;
          </strong>
          . В&nbsp;этом случае данные об&nbsp;конверсиях CRM будут попадать
          в&nbsp;выбранное представление
        </li>
        <li>
          Убедитесь, <strong>что Отчеты User-ID Отключены</strong>
        </li>
        <li>
          Нажмите <strong>Сохранить</strong>.
        </li>

        <figure className={classes.helpArticleFigure}>
          <img src="/images/image3GA.jpg" alt="true" />
        </figure>
      </ol>

      <h3>Шаг 2. Настройки электронной торговли.</h3>
      <ol>
        <li>
          Перейдите в&nbsp;режим <strong>Администратор</strong>
        </li>
        <li>
          Далее в&nbsp;<strong>Настройки электронной торговли</strong>
        </li>
        <figure className={classes.helpArticleFigure}>
          <img src="/images/image5GA.jpg" alt="true" />
        </figure>
        <li>
          Включите <strong>отслеживание электронной торговли</strong>.
        </li>
        <li>
          Включите <strong>отчеты для расширенной электронной торговли</strong>.
        </li>
        <li>
          Нажмите кнопку <strong>Сохранить</strong>.
        </li>
        <figure className={classes.helpArticleFigure}>
          <img src="/images/image2GA.jpg" alt="true" />
        </figure>
      </ol>
      <p>Готово!</p>
    </article>
  )
}

export default style(DSView)
